import { env } from "../../../env";
const axios = require("axios").default;

const URL_ORI = `${env.REACT_APP_API_URL}`;

export const getInventory = (payload) => {
  return axios
    .get(`${URL_ORI}/api/inventory/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getIdReportIssue = (id) => {
  return axios
    .get(`${URL_ORI}/api/inventory/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createReportIssue = (payload) => {
  return axios
    .post(`${URL_ORI}/api/inventory/addReportIssue`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateReportIssue = (payload) => {
  return axios
    .put(`${URL_ORI}/api/inventory/updateReportIssue`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
